"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getScript = exports["default"] = void 0;
// https://github.com/GCC-Autobahn/gcc-autobahn-frontend/blob/master/libraries/gcc-autobahn-utilities/src/get-script/index.js
var getScript = function getScript(source) {
  var container = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.getElementsByTagName('head')[0];
  return new Promise(function (resolve, reject) {
    var script = document.createElement('script');
    script.async = 1;
    script.onerror = function () {
      reject();
    };
    script.onload = function (_, isAbort) {
      if (isAbort || !script.readyState || /loaded|complete/.test(script.readyState)) {
        script.onload = null;
        script.onreadystatechange = null;
        script = undefined;
        if (!isAbort) {
          resolve();
        }
      }
    };
    script.onreadystatechange = script.onload;
    script.src = source;
    container.appendChild(script);
  });
};
exports.getScript = getScript;
var _default = getScript;
exports["default"] = _default;
//# sourceMappingURL=getScript.js.map